import { atom } from 'recoil';
import { PlanType, ServiceType, CnStatusCode } from '@/types/api/mypage/planInfo';
import persistAtom from './recoilPersist';

/**
 * 契約プランの主要情報を画面表示向けに保持する型。
 * 契約種別やステータスで多数の導線分岐があるため、よく使う値をこの state に集約している。
 */
export type PlanInfoStateType = {
  planCode: string; // 料金プランコード
  planName: string; // 料金プラン名称
  cnStatusCode: CnStatusCode | undefined; // 契約ステータス
  cnStatusName: string; // 契約ステータス名称
  planType: PlanType | undefined; // プラン種別
  serviceType: ServiceType | undefined; // サービス種別
  serviceStartDate: string; // サービス開始日
  acceptDate: string; // 受付日
  contractTotalMonth: number; // 契約期間（ヶ月）
  preferredQuitDate: string; // 解約希望日
  canEntryCancel: boolean; // 申込キャンセル可否
  // contractUpdateMonth: string; // 次回更新月
  canQuitCancel: boolean;
};

/**
 * 契約プラン情報を保持する state。
 * 契約情報・オプション・支払変更・解約導線など多くの画面が参照するため、セッション中の基礎情報として保持する。
 */
export const PlanInfoState = atom<PlanInfoStateType>({
  key: 'PlanInfoState',
  default: {
    planCode: '',
    planName: '',
    cnStatusCode: undefined,
    cnStatusName: '',
    planType: undefined,
    serviceType: undefined,
    serviceStartDate: '',
    acceptDate: '',
    contractTotalMonth: 0,
    preferredQuitDate: '',
    canEntryCancel: false,
    // contractUpdateMonth: '',
    canQuitCancel: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export default PlanInfoState;
